import React from 'react';
import PropTypes from 'prop-types';
import ComponentsFactory from 'foundation/components-factory';

class FactCard extends React.Component {
    constructor(props) {
        super(props);

        this.rootRef = React.createRef();
    }

    componentDidMount() {
        ComponentsFactory.getInstance().init(this.rootRef.current);
    }

    componentWillUnmount() {
        ComponentsFactory.getInstance().destroy(this.rootRef.current);
    }

    onClickRoot = () => {
        const { onCardLinkClick, model } = this.props;
        onCardLinkClick(model);
    }

    render() {
        const { model, bemModifiers } = this.props;
        let bemCss = '';

        if (Array.isArray(bemModifiers)) {
            if (model.isDark) {
                bemModifiers.push('dark');
            }

            bemCss = bemModifiers.map((x) => `fact-card--${x}`).join(' ');
        }

        return (
            <a
                className={`fact-card ${bemCss}`}
                href={model.url}
                data-dc-component="modal-spa-trigger"
                ref={this.rootRef}
                onClick={this.onClickRoot}
            >
                <div className="fact-card__content">
                    <p className="fact-card__label">{model.label}</p>
                    <h3 className="fact-card__heading">
                        <b>{model.title}</b>
                    </h3>
                    <div className="fact-card__cta">
                        <span className="fact-card__cta-text">{model.ctaText}</span>
                        <svg className="fact-card__cta-icon icon" width="14" height="12"
                            focusable="false">
                            <use xlinkHref="#icon-arrow-right"></use>
                        </svg>
                    </div>
                </div>
                <div className="fact-card__bg">
                    <img className="lazyload" alt="" data-srcset={model.bgImage} data-sizes="auto" />
                </div>
            </a>
        );
    }
}

FactCard.propTypes = {
    model: PropTypes.object.isRequired,
    bemModifiers: PropTypes.array,
    onCardLinkClick: PropTypes.func,
};

export default FactCard;
